const _CONFIG_ = {
  SITE_URL: "https://i1hengongbet.com/",
  REGISER_URL:
    "https://redirect.hengongbets.win/en-my?regRef=hhstar&merCode=wlm",
};
export default _CONFIG_;
